<template>
  <div class="">
    <div class="head-title">报销审批流程</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、企业报销审批流程的设置。根据企业实际添加不同审批事项名称，并在每个报销审批事项中设置添加审批步骤及审批人，发起审批后将按顺序审批直至最后一个人。
          </p>
          <p>
            2、删除审批人的时候如果该审批人下面有待审批报销将会自动转入下一级审批人，如果没有下一级审批人待审批的状态将自动变成完成状态。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="mMain">
      <nav class="navbar">
        <div class="narbar-l">
          <el-button @click="onSubmit = true" icon="el-icon-plus" type="primary"
            >添加</el-button
          >
        </div>
        <div class="narbar-r">
          <el-input
            clearable
            placeholder="请输入事项名称搜索"
            style="width: 35.0rem;"
            prefix-icon="el-icon-search"
            v-model="input2"
            @change="rune()"
          >
          <el-button slot="append" @click="rune()" type="primary"
            >查询</el-button
          >
          </el-input>

        </div>
      </nav>
      <div style="width: 100%; margin-top: 2.0rem">
        <el-table
          border
          :data="tableData.data"
          v-loading="tableLoading"
        >
          <el-table-column
            prop="name"
            label="事项名称"
            style="width: 10%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createtime"
            label="创建时间"
            style="width: 20%"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" width="300" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="(onSubmitn = true), shenpi(scope.row)"
                >审批步骤</el-button
              >
              <el-button
                type="text"
                size="mini"
                @click="(onSubmitn = true), bianji(scope.row)"
                >修改</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="handleClick(scope.row)"
                style="color:#f00000 !important"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        :total="tableData.count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :page-sizes="[10,20,50,100]"
        :auto-scroll="false"
        @pagination="userTable"
      />
    </div>

    <el-dialog title="添加" center :visible.sync="onSubmit" width="30%">
      <el-form ref="form" :model="form" :rules="rules" label-width="8.0rem">
        <el-form-item label="事项名称" prop="group_name">
          <el-input clearable v-model="form.group_name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit = false">取 消</el-button>
        <el-button type="primary" @click="numoo()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改" center  :visible.sync="onSubmitn" width="30%">
      <el-form ref="form" :model="form" label-width="8.0rem">
        <el-form-item label="事项名称">
          <el-input clearable v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitn = false">取 消</el-button>
        <el-button type="primary" @click="numoon()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
export default {
  name: "monitoring",
  components: {
    Pagination,
  },
  data() {
    return {
      tableData: {
        count: 0,
        data: [],
      },
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        group_name: "",
        tag_name: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      pageSize: "",
      rules: {
        name: [{ required: true, message: "请输入新增名称", trigger: "blur" }],
        group_name: [
          { required: true,  message: "事项名称不能为空", trigger: "blur" },
        ],
        tag_name: [{ required: true, message: "请输入标签", trigger: "blur" }],
      },
      listQuery: {
        page: 1,
        limit: 20,
      },
      tableLoading: true,
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
  },
  methods: {
    shenpi(val) {
      this.$router.push({
        name: "applysadd",
        query: {
          val,
        },
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    tongbu() {
      this.axios
        .post(
          "/crm/Assistant/get_tag",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.userTable();
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    //  页数
    handleCurrentChange(val) {
      this.pageSize = val;
      this.userTable();
    },
    userTable() {
      this.axios
        .post(
          "/crm/ApplyItem/getApplyItemList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            name: this.input2,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableLoading = false;
          this.tableData = res.data;
        })
        .catch(function (err) {});
    },
    rune() {
      this.userTable();
    },

    handleSelectionChange(val) {
      this.yeshu = 1;
      this.multipleSelection = val;
    },
    bianji(e) {
      this.ele = e;
      this.form.name = e.name;
    },
    // 修改
    numoon() {
      if(this.form.name.trim() == ""){
        this.$message.error('事项名称不能为空');
        return
      }
      this.axios
        .post(
          "/crm/ApplyItem/editApplyItem",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            name: this.form.name,
            id: this.ele.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.userTable();
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    // 添加
    numoo() {
      if(this.form.group_name.trim()==""){
        this.$message.error("事项名称不能为空");
        return;
      }
      this.axios
        .post(
          "/crm/ApplyItem/addApplyItem",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            name: this.form.group_name,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.userTable();
            this.form.group_name=""
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    // 移除
    handleClick(e) {
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/ApplyItem/delApplyItem",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e.id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
            type: "info",
          });
        });
    },
  },
};
</script>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
nav {
  width: 100%;
}
.shij {
  display: inline-block;
  margin-right: 2.4rem;
}
</style>
